import * as Routes from 'constants/Routes'
import { logout } from 'common/actions/auth'

const createLogoutRoute = store => ({
  path: Routes.LOGOUT,
  onEnter: () => {
    store.dispatch(logout())
  }
})

export default createLogoutRoute
